module.exports = __webpack_public_path__ + "static/19-5b600d6f33b30f8c756d008da75a836d.jpg";